import React from 'react';
import Seo from '../components/Seo';
import { useLanguage } from '../contexts/LanguageContext';
import CtaSection from '../components/CtaSection';

const VeneersPage: React.FC = () => {
  const { translations } = useLanguage();

  return (
    <main className="pt-20 lg:pt-32">
      <Seo pageKey="veneers" />
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.veneers.title}</h1>
          <p className="text-xl">{translations.veneers.intro.split('.')[0]}.</p>
        </div>
      </div>

      <section className="py-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <img
                src="/images/SeaDent Veneers.jpg"
                alt={translations.veneers.imageAlt}
                className="rounded-lg shadow-lg w-full"
              />
            </div>
            <div>
              <p className="mb-6 text-lg">{translations.veneers.description}</p>
            </div>
          </div>
        </div>
      </section>

      <CtaSection />
    </main>
  );
};

export default VeneersPage; 